import { useApi } from './useApi'
import { uploadMetadataImage } from './useLinkMetadata'

// Metadata de la portada y ajustes que valen para todo el sitio. Sólo responde
// a superusuarios; el resto de la app usa useLinkMetadata (por congregación).
export const useSiteMetadata = () => {
  const api = useApi()

  const getSiteMetadata = () => api.get('/api/admin/site-metadata')

  const saveSiteMetadata = (payload) => api.put('/api/admin/site-metadata', payload)

  const resetSiteMetadata = () => api.del('/api/admin/site-metadata')

  const uploadImage = (file) => uploadMetadataImage('/api/admin/site-metadata/images', file)

  const deleteImage = (id) => api.del(`/api/admin/site-metadata/images/${id}`)

  return { getSiteMetadata, saveSiteMetadata, resetSiteMetadata, uploadImage, deleteImage }
}
